import { createBrowserHistory } from 'history';
import main from './main';
import configureStore from './store/configureStore';
import { glamorPlugins } from './glamor';

glamorPlugins();

const store = configureStore();
const history = createBrowserHistory();

main(store, history);
